<script>
  const BASE_URL = window.location.protocol + "//" + window.location.host; // 设置全局 URL  
  // const BASE_URL = 'http://115.29.32.174:8080';
  export default{//http://yyqwx.rr4j.com
    BASE_URL
  }
</script>


// WEBPACK FOOTER //
// src/Base.vue